export default __webpack_public_path__ + "static/media/CoLAB.48ecbc97.png";